import Vue from 'vue'
import App from './App'
import router from './router'
import store from "./store/index"
import VueWechatTitle from "vue-wechat-title";
import "./assets/scss/index.scss"
import "./assets/css/index.css"
import md5 from 'js-md5';
import WebIM from "./utils/WebIM";


import videoPlayer from 'vue-video-player'
import 'video.js/dist/video-js.css'
import hls from 'videojs-contrib-hls'
import Url from "@/components/api/url";

import './assets/iconfont/iconfont.js'

import * as echarts from "echarts";

Vue.prototype.$echarts = echarts;

// const VUE_APP_VERSION = require('../package.json').version
// const vers = window.localStorage.getItem("appVersion");
// if (VUE_APP_VERSION != vers) {
//   localStorage.clear()
//   window.localStorage.setItem("appVersion", VUE_APP_VERSION);
//   location.reload()
// }
Vue.use(hls)
Vue.use(videoPlayer)
Vue.prototype.md5 = md5;
Vue.use(VueWechatTitle);


if(process.env.NODE_ENV==="production"){  //生产环境不展示console
  console.log = () => {}
}


import {
  Button, Toast, Icon, Swipe, SwipeItem, NoticeBar, Lazyload, List, Overlay, Loading, Badge, Field, Dialog, Popup, Stepper,
  CountDown, Rate, Uploader, RadioGroup, Radio, Cascader, Checkbox, CheckboxGroup, ActionSheet, Cell, Calendar, PasswordInput,
  NumberKeyboard, Step, Steps, PullRefresh, AddressList, AddressEdit, Switch, DropdownMenu, DropdownItem, Search, ShareSheet
  , Progress, CellGroup, Col, Row, ImagePreview,Empty, Tab, Tabs,Sidebar, SidebarItem,SwipeCell,Form,DatetimePicker,Collapse, CollapseItem,
  Picker,Area,Divider,Tag 
} from 'vant';
Vue.use(Button).use(Icon).use(Toast).use(Swipe).use(SwipeItem).use(NoticeBar).use(Lazyload).use(List).use(Overlay).use(Loading)
  .use(Badge).use(Field).use(Dialog).use(Popup).use(Stepper).use(CountDown).use(Rate).use(Uploader).use(RadioGroup).use(Radio)
  .use(Cascader).use(Checkbox).use(CheckboxGroup).use(ActionSheet).use(Cell).use(Calendar).use(PasswordInput).use(NumberKeyboard)
  .use(Step).use(Steps).use(PullRefresh).use(AddressList).use(AddressEdit).use(Switch).use(DropdownMenu).use(DropdownItem)
  .use(Search).use(ShareSheet).use(Progress).use(CellGroup).use(Col).use(Row).use(ImagePreview).use(Empty).use(Tab).use(Tabs).use(Sidebar)
  .use(SidebarItem).use(SwipeCell).use(Form).use(DatetimePicker).use(Collapse).use(CollapseItem).use(Picker).use(Area).use(Divider).use(Tag)
Toast.setDefaultOptions({
  duration: 3000,
  position: "center"
})
Vue.prototype.Url = Url.Url
Vue.prototype.imgUrl = Url.imgUrl
Vue.prototype.imgUrl1 = Url.imgUrl1
Vue.prototype.wsUrl = Url.wsUrl
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  store,
  WebIM,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js